import styled from 'styled-components';
import { fontDisplay, fontUi } from '../../theme/typography';

export const StyledTitle = styled.h1`
  ${fontDisplay};
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text};
  margin: 0 0 8px;

  @media only screen and (max-width: 768px) {
    font-size: 24px;
    margin-top: 16px;

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const StyledSubTitle = styled.h3`
  ${fontDisplay};
  font-size: 18px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text};
  margin: 24px 0 8px;
  line-height: 1.3;
`;

export const StyledParagraph = styled.div`
  ${fontUi};
  font-size: 15px;
  font-weight: 400;
  line-height: 1.55;
  color: ${({ theme }) => theme.textMuted};

  p {
    margin: 0 0 12px;
  }

  ul,
  ol {
    margin: 8px 0 12px;
    padding-left: 22px;
  }

  li {
    margin: 4px 0;
  }

  a {
    color: ${({ theme }) => theme.accent};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  br {
    display: block;
    margin-top: 8px;
  }
`;
